import { ErrorType } from '../../models/HttpError';
import { AppThunkAction } from '../reducers';

// services
import * as Services from '../../services/SettlementResume.Services';

// actions
import * as Actions from '../actions';
import { SettlementResume } from '../../models/Entities/SettlementResume/SettlementResume';

type KnownAction =
    | Actions.SettlementsResume.SettlementResume_GetAll_Request_Action
    | Actions.SettlementsResume.SettlementResume_GetAll_Receive_Action
    | Actions.SettlementsResume.SettlementResume_GetAll_Fail_Action;

export const actionCreators = {
    GetAllSettlementResume:
        (settlementId: number): AppThunkAction<KnownAction> =>
        async (dispatch, getState) => {

            var state = getState();
            var token: string;

            if (state.oidc?.user?.access_token === undefined) {
                dispatch({
                    type: 'SETTLEMENTRESUME_GETALL_FAIL_ACTION',
                    error: {
                        ErrorCode: 401,
                        ErrorMessage: 'Not authorized',
                        Errors: []
                    }
                });
                return;
            } else {
                token = state.oidc.user.access_token;
            };

           
            dispatch({
                type: 'SETTLEMENTRESUME_GETALL_REQUEST_ACTION',
                settlementId: settlementId
            });

            Services.GetResumesBySettlementId(settlementId, token)
            .then((settlementResumes: SettlementResume[]) => {
                dispatch({
                    type: 'SETTLEMENTRESUME_GETALL_RECEIVE_ACTION',
                    settlementResumes: settlementResumes,
                    settlementId: settlementId
                });
            })
            .catch((error: ErrorType) =>
                dispatch({
                    type: 'SETTLEMENTRESUME_GETALL_FAIL_ACTION',
                    settlementId: settlementId,
                    error: error
                })
            );
    },
    
};
